import React from 'react';
import { Container, FakePlate, Header, Plate, Row, SubHeader } from 'features/shared/ui/Page';
import UnauthorizedLayout from 'features/shared/layouts/unauthorized';
import Spacer from 'features/shared/Spacer';
import SwitchTabs, { SwitchTabsType } from 'features/shared/SwitchTabs';
import { useBannersContext } from 'features/shared/Banners/BannersContext';
import Banners from 'features/shared/Banners/Banners';
import { UnauthPlateText } from 'features/shared/UnauthPlateText';

const Schools = () => {
  const { banners } = useBannersContext({ section: 'main' });
  return (
    <UnauthorizedLayout>
      <Container>
        <Header>Школы</Header>
        <Spacer size={32} />
        <Plate data-qa-id="totals_block">
          <SubHeader>Основные показатели</SubHeader>
          <Spacer size={24} />
          <FakePlate style={{ padding: 28 }}>
            <UnauthPlateText />
          </FakePlate>
        </Plate>
        <Spacer size={40} />
        {banners.length ? (
          <>
            <Banners section="main" />
            <Spacer size={40} />
          </>
        ) : null}
        <Plate data-qa-id="statistics_block">
          <SubHeader>Статистика по региону и муниципалитетам</SubHeader>
          <Spacer size={24} />
          <SwitchTabs
            values={[
              { id: 'УЧЕНИКИ', label: 'УЧЕНИКИ' },
              { id: 'УЧИТЕЛЯ', label: 'УЧИТЕЛЯ' },
              { id: 'КЛАССЫ', label: 'КЛАССЫ' },
            ]}
            value={{ id: 'УЧЕНИКИ', label: 'УЧЕНИКИ' }}
            type={SwitchTabsType.pills}
          />
          <Spacer size={40} />
          <FakePlate style={{ padding: '197px 0' }}>
            <UnauthPlateText />
          </FakePlate>
        </Plate>
        <Spacer size={40} />
        <Plate data-qa-id="active_schools_block">
          <SubHeader>Активность учеников на сервисах Учи.ру</SubHeader>
          <Spacer size={16} />
          <FakePlate style={{ padding: '370px 0' }}>
            <UnauthPlateText />
          </FakePlate>
        </Plate>
        <Spacer size={40} />
        <Plate data-qa-id="active_students_block">
          <SubHeader>Список муниципалитетов с активными школами</SubHeader>
          <Spacer size={25} />
          <FakePlate style={{ padding: '381px 0' }}>
            <UnauthPlateText />
          </FakePlate>
        </Plate>
      </Container>
    </UnauthorizedLayout>
  );
};

export default Schools;
